module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/index.js
// module id = 510
// module chunks = 5 7 8 9 10 13 15 17 23 57 58